import React from 'react';
const CustomerSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-customer" });
CustomerSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-customer sirius-icon-customer-enhance" });
export default CustomerSvg;
